import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

const Account = () => {
  const { login, register, isLoggedIn, user, logout } = useAuth();
  const [loginEmail, setLoginEmail] = useState('');
  const [loginPass, setLoginPass] = useState('');
  const [regName, setRegName] = useState('');
  const [regEmail, setRegEmail] = useState('');
  const [regPass, setRegPass] = useState('');
  const [loginMsg, setLoginMsg] = useState('');
  const [regMsg, setRegMsg] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault(); setLoginMsg(''); setLoading(true);
    const res = await login(loginEmail, loginPass);
    setLoading(false);
    if (res.success) setLoginMsg('Logged in successfully!');
    else setLoginMsg(res.message || 'Login failed');
  };

  const handleRegister = async (e) => {
    e.preventDefault(); setRegMsg(''); setLoading(true);
    const res = await register(regName, regEmail, regPass);
    setLoading(false);
    if (res.success) setRegMsg('Registered & logged in!');
    else setRegMsg(res.message || 'Registration failed');
  };

  if (isLoggedIn) {
    return (
      <section className="account py-80">
        <div className="container container-lg">
          <div className="border border-gray-100 rounded-16 px-24 py-40" style={{ maxWidth: 480 }}>
            <h6 className="text-xl mb-24">Welcome, {user?.name || user?.email || 'User'}</h6>
            <p className="text-gray-500 mb-32">{user?.email}</p>
            <button onClick={logout} className="btn btn-main py-18 px-40">Log out</button>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="account py-80">
      <div className="container container-lg">
        <div className="row gy-4">
          {/* Login Card */}
          <div className="col-xl-6 pe-xl-5">
            <div className="border border-gray-100 hover-border-main-600 transition-1 rounded-16 px-24 py-40 h-100">
              <h6 className="text-xl mb-32">Login</h6>
              {loginMsg && (
                <div style={{ padding: '8px 14px', marginBottom: 16, background: loginMsg.includes('!') ? '#d1fae5' : '#fee2e2', borderRadius: 6 }}>
                  {loginMsg}
                </div>
              )}
              <form onSubmit={handleLogin}>
                <div className="mb-24">
                  <label htmlFor="loginEmail" className="text-neutral-900 text-lg mb-8 fw-medium">
                    Email address <span className="text-danger">*</span>
                  </label>
                  <input type="email" className="common-input" id="loginEmail" placeholder="Enter Email Address" value={loginEmail} onChange={e => setLoginEmail(e.target.value)} required />
                </div>
                <div className="mb-24">
                  <label htmlFor="loginPass" className="text-neutral-900 text-lg mb-8 fw-medium">Password</label>
                  <input type="password" className="common-input" id="loginPass" placeholder="Enter Password" value={loginPass} onChange={e => setLoginPass(e.target.value)} required />
                </div>
                <div className="mb-24 mt-48">
                  <div className="flex-align gap-48 flex-wrap">
                    <button type="submit" className="btn btn-main py-18 px-40" disabled={loading}>
                      {loading ? 'Logging in…' : 'Log in'}
                    </button>
                    <div className="form-check common-check">
                      <input className="form-check-input" type="checkbox" id="remember" />
                      <label className="form-check-label flex-grow-1" htmlFor="remember">Remember me</label>
                    </div>
                  </div>
                </div>
                <div className="mt-48">
                  <Link to="#" className="text-danger-600 text-sm fw-semibold hover-text-decoration-underline">
                    Forgot your password?
                  </Link>
                </div>
              </form>
            </div>
          </div>
          {/* Register Card */}
          <div className="col-xl-6">
            <div className="border border-gray-100 hover-border-main-600 transition-1 rounded-16 px-24 py-40">
              <h6 className="text-xl mb-32">Register</h6>
              {regMsg && (
                <div style={{ padding: '8px 14px', marginBottom: 16, background: regMsg.includes('!') ? '#d1fae5' : '#fee2e2', borderRadius: 6 }}>
                  {regMsg}
                </div>
              )}
              <form onSubmit={handleRegister}>
                <div className="mb-24">
                  <label htmlFor="regName" className="text-neutral-900 text-lg mb-8 fw-medium">Full Name <span className="text-danger">*</span></label>
                  <input type="text" className="common-input" id="regName" placeholder="Write your name" value={regName} onChange={e => setRegName(e.target.value)} required />
                </div>
                <div className="mb-24">
                  <label htmlFor="regEmail" className="text-neutral-900 text-lg mb-8 fw-medium">Email address <span className="text-danger">*</span></label>
                  <input type="email" className="common-input" id="regEmail" placeholder="Enter Email Address" value={regEmail} onChange={e => setRegEmail(e.target.value)} required />
                </div>
                <div className="mb-24">
                  <label htmlFor="regPass" className="text-neutral-900 text-lg mb-8 fw-medium">Password <span className="text-danger">*</span></label>
                  <input type="password" className="common-input" id="regPass" placeholder="Enter Password" value={regPass} onChange={e => setRegPass(e.target.value)} required />
                </div>
                <div className="my-48">
                  <p className="text-gray-500">
                    Your personal data will be used to process your order, support your experience throughout this website, and for other purposes described in our{' '}
                    <Link to="#" className="text-main-600 text-decoration-underline">privacy policy</Link>.
                  </p>
                </div>
                <div className="mt-48">
                  <button type="submit" className="btn btn-main py-18 px-40" disabled={loading}>
                    {loading ? 'Registering…' : 'Register'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Account
